/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { capitalizeWords } from '../../../utilities/capitalizeWords';
import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
} from '@mui/material';
import { CustomTableCell } from '../../index';
import { formatISOToPHT } from '../../../utilities/date';

export const CivilService = (props) => {
  return (
    <Box sx={{ mb: 3, padding: '12px' }}>
      <TableContainer
        sx={{
          height: '100%',
          width: '100%',
          overflow: 'auto',
          padding: '12px',
        }}
      >
        <Table sx={{ width: '100%' }}>
          <TableHead>
            <TableRow>
              <CustomTableCell value="Service Type" />
              <CustomTableCell value="Rating" />
              <CustomTableCell value="Date of Examination/Conferment" />
              <CustomTableCell value="License Number" />
              <CustomTableCell value="Date of Release" />
            </TableRow>
          </TableHead>
          {props.empCivService?.map((civService) => (
            <TableRow key={civService._id}>
              <TableCell>{capitalizeWords(civService.servicetype)}</TableCell>
              <TableCell>{capitalizeWords(civService.rating)}</TableCell>
              <TableCell>{formatISOToPHT(civService.dateofexam)}</TableCell>
              <TableCell>{civService.licensenumber}</TableCell>
              <TableCell>{formatISOToPHT(civService.dateofrelease)}</TableCell>
            </TableRow>
          ))}
        </Table>
      </TableContainer>
    </Box>
  );
};
